import type { TrafficRelatedBy, TrafficTopDimension } from '@bartizo/shared';

/** What is worth showing beside a top-list row, per kind of row (P11.13). */
export interface Relation {
  show: TrafficRelatedBy;
  title: string;
}

/** For each kind of row: what is worth showing beside it, in the order a person asks. */
export const RELATIONS: Readonly<
  Partial<Record<TrafficTopDimension, { by: TrafficRelatedBy; shows: Relation[] }>>
> = {
  path: {
    by: 'path',
    shows: [
      { show: 'ip', title: 'Who asked for it' },
      { show: 'status', title: 'How it was answered' },
      { show: 'bot', title: 'Which bots' },
    ],
  },
  ip: {
    by: 'ip',
    shows: [
      { show: 'path', title: 'What it asked for' },
      { show: 'status', title: 'How it was answered' },
      { show: 'bot', title: 'Presented as' },
    ],
  },
  bot: {
    by: 'bot',
    shows: [
      { show: 'path', title: 'Pages it asked for' },
      { show: 'status', title: 'How it was answered' },
      { show: 'ip', title: 'From addresses' },
    ],
  },
  status: {
    by: 'status',
    shows: [
      { show: 'path', title: 'Which pages' },
      { show: 'ip', title: 'Who got it' },
    ],
  },
};

export const hasRelated = (dimension: TrafficTopDimension): boolean =>
  RELATIONS[dimension] !== undefined;
